export default __webpack_public_path__ + "static/media/img2.fd0a7fcd.png";